<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Sổ sách chủ nhiệm" :link="[{ text: 'Sổ sách chủ nhiệm', href: '../classDoc' }]" />
      </div>
    </div>
    <div v-if="loading" class="loading-container">
      <v-progress-circular indeterminate size="40"></v-progress-circular>
    </div>
    <div v-else class="pa-4">
      <v-card outlined class="pa-6 mx-0 mb-6 elevation-0">
        <FilterClassTree @onFilterChanged="getFile" />
      </v-card>
      <v-row no-gutters>
        <v-col cols="4" class="pr-6">
          <v-card outlined class="elevation-0 view-table" style="background-color: #ffffff">
            <v-card-title style="position: sticky; top: 0; background-color: white; z-index: 1;">
              Thư mục
            </v-card-title>
            <v-card-text class="pb-0">
              <div v-for="(node, index) in organizedData" :key="index">
                <TreeNode :node="node" @setItem="setSelectedItemForTable" />
              </div>
              <div style="height: 24px; background-color: white; position: sticky; bottom: 0;"></div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="8">
          <DocCatTable :content="selectedItem" @refresh="refreshDocumentTable" ref="dataTable" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { AcademicLevel, TeacherCat } from '@/plugins/api'
import { mapActions, mapState } from 'vuex'

import DocCatTable from '../../components/basic/tree/DocCatTable.vue'
import TreeNode from '../../components/basic/tree/TreeNode.vue'
import FilterClassTree from '../../components/basic/tree/FilterClassTree.vue'

export default {
  components: {
    Breadcrumbs,
    DocCatTable,
    FilterClassTree,
    TreeNode
  },

  data() {
    return {
      loading: true,
      selectedCard: null,
      selectedItem: { catId: null, currId: null, subType: '', type: null, subjectGroupId: '' },
      organizedData: []
    }
  },
  computed: {
    ...mapState({
      docCategories(state) {
        return state['docCategory'].docCategories
      },
      profile(state) {
        return state['auth'].profile
      }
    })
  },
  methods: {
    ...mapActions({
      fetchTree: 'docCategory/fetchTree',
      fetchTeachings: 'teacherDoc/fetchTeachings',
      fetchDocument: 'gradeDocument/fetchDocument'
    }),
    async setSelectedItemForTable(item) {
      this.selectedItem = item
      this.$nextTick(() => {
        this.$refs.dataTable.loadDocuments()
      })
    },

    async getFile(item) {
      await this.initializeTeachingsTree(item)
    },
    async refreshDocumentTable(item) {
      this.$loading.active = true
      try {
        await this.fetchDocument({ docCategory: item._id })
      } catch (error) {
        this.$alert.error('Không tải được tài liệu')
      } finally {
        this.$loading.active = false
      }
    },
    async initializeTeachingsTree(item) {
      this.$loading.active = true
      try {
        this.organizedData = await TeacherCat.fetchClassTree(item.grade)
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      } finally {
        this.$loading.active = false
      }
    }
  },

  async mounted() {
    try {
      const acaLevels = await AcademicLevel.fetch({ status: 'active' })
      acaLevels.sort((a, b) => {
        const numberA = Number(a.title.slice(-1))
        const numberB = Number(b.title.slice(-1))
        return numberA - numberB
      })
      this.academicLevels = acaLevels || []
    } catch (error) {
      console.error('Error fetching academic levels:', error)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.card-container {
  /* display: flex; */
  align-items: center;
  position: relative;
  width: 400px;
}

.card {
  transition: transform 0.3s ease;
  width: 500px;
}

.card-buttons {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  position: absolute;
  right: -30px;

  transition: opacity 0.3s ease;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.view-table {
  height: 468px;
  max-height: 468px;
  overflow-y: auto;
}
</style>
